import React, { Component } from 'react';
import Cognito from "src/js/Cognito.js";
import Api from 'src/js/Api.js';
import { Route, Switch } from 'react-router-dom';
import TripListTable from 'src/component/TripReport/TripListTable';
import ScoreGraph from 'src/component/Util/ScoreGraph';
import DatePikerForm from 'src/component/Util/DatePikerForm';
import { Button, Row, Col, OverlayTrigger, Popover} from 'react-bootstrap';
// import { Popover } from 'react-bootstrap/lib/Popover';
import moment from 'moment';
import Modal from 'src/js/Modal.js'
import ApiErrorModal from 'src/js/ApiErrorModal.js';
import Config from 'src/config.json';
import 'src/css/TripReport.css'
// import { Tooltip } from 'chart.js';
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class TripReport extends Component {

  constructor() {
    super();
    let today = new Date();
    this.state = {
      // ログイン中ユーザ
      cognitoUser: [],
      // ログイン者のsub
      sub:'',
      // 車両のカープレートNO
      carPlateNo: '', 
      // 選択可能な最小の日
      minDate: "0/1/2018",
      // 日次スコアグラフデータ
      dailyScoreGraphData: {},
      // 日次グラフデータ
      dailyScoreGraphLabels: {},
      // 日次スコアグラフデータローディング
      dailyScoreGraphLoading: true,
      // 日次スコアグラフデータ存在フラグ
      isDailyScoreGraph: true,
      // 日次スコアグラフデータ開封フラグ
      isOpenDailyScoreGraph: false, 
      // トリップ一覧データ
      tripListData: [],
      // トリップ一覧開始日
      tripListFrom: '',
      // トリップ一覧終了日
      tripListTo: '',
      // トリップ一覧取得フラグ
      isTripList: false,
      // トリップ一覧ローディング
      tripListLoading: false,
      // トリップ詳細ローディング
      tripDetailLoading: false,
      // 検索結果ページング番号
      searchResultPageNum: 1,
      // トリップ一覧で選択されたトリップの開始時間
      startTime: '',
      // トリップ一覧ページング番号
      tripListPageNum: 1,
      // トリップ一覧ソート名
      tripListSortName: undefined,
      // トリップ一覧ソート順
      tripListSortOrder: undefined,
      // トリップ一覧のリンクが押されたか
      isLink: false,
      modalApiPath: "",
      modalStatusCode: "",
      modalErrorMessage: "",
      modalApiMessage: "",
      today: `${("0" + today.getDate()).slice(-2)}/${("0" + (today.getMonth() + 1)).slice(-2)}/${today.getFullYear()}`,
    }

    this.getTripListData = this.getTripListData.bind(this);
    this.onClickTripListCell = this.onClickTripListCell.bind(this);
    this.formatTripListCell = this.formatTripListCell.bind(this);
    this.onTripListSortChange = this.onTripListSortChange.bind(this);
    this.onTripListPageChange = this.onTripListPageChange.bind(this);
    this.getDailyScoreGraph = this.getDailyScoreGraph.bind(this);
    this.getLocalStorageData = this.getLocalStorageData.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.onClick = this.onClick.bind(this);
    this.selectDateFrom = this.selectDateFrom.bind(this);
    this.selectDateTo = this.selectDateTo.bind(this);
  }

  componentWillMount() {
    // 認証チェック
    if (Cognito.signInCheck()) {
      // ユーザを取得
      this.setState({ cognitoUser: Cognito.getCognitoUser() });
    }
    // 描画前にローカルストレージからデータを取得する
    this.getLocalStorageData();
  }

  componentDidMount() {
    // ページの一番上までスクロール
    window.scrollTo(0, 0);
    if(!this.state.isTripList){
      this.getTripListData();
    }
    this.getDailyScoreGraph();
  }

  handleHideModal() {
    this.setState({ showModal: false })
  }

  handleShowModal() {
    this.setState({ showModal: true })
  }

  // ローカルストレージの値を取得
  getLocalStorageData() {
    // サブ情報
    let sub = localStorage.getItem('sub');
    if (sub) {
      this.setState({
        sub: sub
      });
    }

    // カープレートNO
    let carPlateNo = localStorage.getItem('carPlate');
    if (carPlateNo) {
      this.setState({
        carPlateNo: carPlateNo,
        carInfoLoading: true,
        isCarInfo: true
      });
    }

    // トリップ一覧
    let localTripListData = JSON.parse(localStorage.getItem('tripListData'));
    if (localTripListData) {
      this.setState({
        tripListData: localTripListData,
        isTripList: true
      })
    }

    // トリップ一覧ページング位置
    let localTripListPageNum = JSON.parse(localStorage.getItem('tripListPageNum'))
    if (localTripListPageNum) {
      this.setState({
        tripListPageNum: localTripListPageNum
      })
    }

    // トリップ一覧ソート名
    let localTripListSortName = JSON.parse(localStorage.getItem('tripListSortName'))
    if (localTripListSortName) {
      this.setState({
        tripListSortName: localTripListSortName
      })
    }

    // トリップ一覧ソート順
    let localTripListSortOrder = JSON.parse(localStorage.getItem('tripListSortOrder'))
    if (localTripListSortOrder) {
      this.setState({
        tripListSortOrder: localTripListSortOrder
      })
    }

    // トリップ一覧期間指定From
    let localTripListFrom = localStorage.getItem('tripListFrom')
    if (localTripListFrom) {
      this.setState({
        tripListFrom: localTripListFrom
      })
    }

    // トリップ一覧期間指定To
    let localTripListTo = localStorage.getItem('tripListTo')
    if (localTripListTo) {
      this.setState({
        tripListTo: localTripListTo
      })
    }
  }

  // From日付選択時レポート情報を再取得
  selectDateFrom(date){
    const from = date.format('DD/MM/YYYY');

    this.setState({ 
      tripListFrom: from
    }, function () {
      this.getTripListData();
    });
  }

  // To日付選択時レポート情報を再取得
  selectDateTo(date){
    const to = date.format('DD/MM/YYYY');

    this.setState({ 
      tripListTo: to
    }, function () {
      this.getTripListData();
    });
  }

  // 最新日次スコアを取得
 getDailyScoreGraph() {
   // subが無い場合は失敗とする
   if (!this.state.sub) {
     this.setState({
       isDailyScoreGraph: false,
       dailyScoreGraphLoading: false
     });
     return;
   }

   let _this = this;

   let queryParams = {
     sub: this.state.sub,
   };

   this.setState({
     isDailyScoreGraph: true,
     dailyScoreGraphLoading: true,
   })

   // APIの実行
   Api.runApi(this.state.cognitoUser, Config.API.STAGE + Config.API.TRIP_REPORT.DAILY_GRAPH_DATA_PATH, queryParams)
     .then(function onFulfilled(result) {
       // Stateを更新
       _this.setState({
         dailyScoreGraphData: result.data,
         dailyScoreGraphLabels: result.data.labels,
         dailyScoreGraphLoading: false
       });
     })
     .catch(function onRejected(err) {
       console.log(err);
       _this.setState({
         isDailyScoreGraph: false,
         dailyScoreGraphLoading: false,
         showModal: true,
         modalErrorMessage: "DailyScoreGraphApiError",
         modalApiPath: err.response && err.response.request.responseURL,
         modalStatusCode: err.response && err.response.status,
         modalApiMessage: err.response && err.response.data.errorMessage,
         error: !err.response && err
       });
       return;
     });
 }

  // トリップ一覧を取得する
  getTripListData() {
    // subが無い場合は失敗とする
    if (!this.state.sub) {
      this.setState({
        isDailyScoreGraph: false,
        dailyScoreGraphLoading: false
      });
      return;
    }

    let _this = this;

    _this.setState({
      isTripList: true,
      tripListLoading: true,
    });

    localStorage.removeItem("tripListPageNum");

    let from = this.state.tripListFrom;
    let to = this.state.tripListTo;

    let queryParams = {
      sub: this.state.sub,
      targetFrom: from,
      targetTo: to,
    }

    // APIの実行
    Api.runApi(this.state.cognitoUser, Config.API.STAGE + Config.API.TRIP_REPORT.TRIP_LIST_DATA_PATH, queryParams)
      .then(function onFulfilled(result) {
        // fromとtoが存在しない場合データから取得
        if(from === '' && to === ''){
          if (result.data.length !== 0) {
            from = moment(result.data[0].tripStartDate, 'YYYY/MM/DD HH:mm:ss.dddddd').format('DD/MM/YYYY');
            to = moment(result.data[result.data.length - 1].tripStartDate, 'YYYY/MM/DD HH:mm:ss.dddddd').format('DD/MM/YYYY');
          }else{
            from = moment().subtract(1, 'months').format('DD/MM/YYYY');
            to = moment().format('DD/MM/YYYY');
          }
        }
        _this.setState({
          tripListData: result.data,
          tripListLoading: false,
          tripListSortName: 'tripStartDate',
          tripListSortOrder: 'desc',
          tripListPageNum: 1,
          tripListFrom: from,
          tripListTo: to,
        });
  
        // ローカルストレージに保存
        localStorage.setItem('tripListSortName', JSON.stringify('tripStartDate'));
        localStorage.setItem('tripListSortOrder', JSON.stringify('desc'));
        localStorage.setItem('tripListPageNum', 1);
  
        // トリップ一覧をローカルストレージに保存
        localStorage.setItem('tripListData', JSON.stringify(result.data));
  
        // 期間指定フォーム情報を保存
        localStorage.setItem('tripListFrom', from);
        localStorage.setItem('tripListTo', to);

      })
      .catch(function onRejected(err) {
        console.log(err);
        _this.setState({
          isTripList: false,
          tripListLoading: false,
          showModal: true,
          modalErrorMessage: "TripListApiError",
          modalApiPath: err.response && err.response.request.responseURL,
          modalStatusCode: err.response && err.response.status,
          modalApiMessage: err.response && err.response.data.errorMessage,
          error: !err.response && err
        });
        return;
      });
  }

  // トリップ一覧のStartTimeリンクを押下した時、データを取得して画面遷移
  onClickTripListCell(event) {

    event.preventDefault()

    let _this = this;

    // 現在のページング位置を取得
    let activePage = document.getElementsByClassName('active page-item');
    let pageElement = activePage[0].getElementsByTagName('a');
    let startTime = event.target.getAttribute("data-time");

    this.setState({
      startTime: startTime,
      tripListPageNum: Number(pageElement[0].innerText)
    }, function () {
      localStorage.setItem('startTime', startTime);
      localStorage.setItem('tripListPageNum', pageElement[0].innerText);
      // トリップレポート詳細画面に遷移
      _this.props.history.push("/trip_report/detail");
    });
    return;
  }

  // トリップ一覧のセルに表示するテキストのフォーマット(リンクにするため)
  formatTripListCell(cell, row) {
    //フォーマット設定しリンクで表示
    let date = moment(cell, 'YYYY/MM/DD HH:mm:ss.dddddd');
    return (
      <a data-time={cell} href='/trip_report/detail' onClick={this.onClickTripListCell}>{date.format('DD/MM/YYYY')}<br />{date.format('HH:mm:ss')}</a>
    );
  }

  // トリップ一覧のソート変更時
  onTripListSortChange(sortName, sortOrder) {
    // ローカルストレージに保存
    localStorage.setItem('tripListSortName', JSON.stringify(sortName));
    localStorage.setItem('tripListSortOrder', JSON.stringify(sortOrder));
    this.setState({
      tripListSortName: sortName,
      tripListSortOrder: sortOrder,
    });
  }

  // トリップ一覧のページング時
  onTripListPageChange(page, pageSize) {
    // ローカルストレージに保存
    localStorage.setItem('tripListPageNum', page);
    this.setState({
      tripListPageNum: page
    });
  }

  onClick() {
    this.setState({
      isOpenDailyScoreGraph: this.state.isOpenDailyScoreGraph ? false :true
    });
  }

  render() {
    const {t} = this.props

    const popoverbottom = (
      <Popover id="popover-bottom" className="PopoverLayout">
        <Col md={6} sm={6} xs={12} className="Graph">
          <ScoreGraph 
            title={t('TripReport.DailyScore')}
            graphData={this.state.dailyScoreGraphData} 
            labels={this.state.dailyScoreGraphLabels}
            isData={this.state.isDailyScoreGraph} 
            loading={this.state.dailyScoreGraphLoading} />
        </Col>
      </Popover>
    );

    if (this.state.error) {
      throw new Error(this.state.error);
    }

    return (
      <div>
        <Modal isAospBrowser={false} isLocalStorage={true} />
        <Switch>
          {/* トリップレポート画面 */}
          <Route exact path="/trip_report">
            <div>
              {this.state.showModal && (
                <ApiErrorModal
                  handleHideModal={this.handleHideModal}
                  modalErrorMessage={this.state.modalErrorMessage}
                  modalApiPath={this.state.modalApiPath}
                  modalStatusCode={this.state.modalStatusCode}
                  modalApiMessage={this.state.modalApiMessage}
                />
              )}
              <Row>
                {/* スコアチャート部 */}
                  <Col md={6} sm={6} xs={6}>
                    <div>
                      {t('TripReport.CarPlate')}
                    </div>
                  </Col>
                  <Col md={6} sm={6} xs={6}>
                    <div>
                      {this.state.carPlateNo}
                    </div>
                  </Col>
                <Col md={12} sm={12} xs={12}>
                  <div className="small-div"></div>
                </Col>
                <Col md={12} sm={12} xs={12}>
                  <OverlayTrigger
                    placement="bottom"
                    trigger="click"
                    overlay={popoverbottom}>
                    <Button block variant="primary" className="daily-score">
                      {t('Common.ScoreChart')}
                    </Button>
                  </OverlayTrigger>
                </Col>
              </Row>
              <Row>
                <Col md={5} sm={5} xs={5} className="datePicker">
                  <DatePikerForm 
                    englishDate={this.state.tripListFrom} 
                    maxDate={this.state.tripListTo} 
                    minDate={this.state.minDate}
                    isDate={true} 
                    selectDate={this.selectDateFrom} 
                  />
                </Col>
                <Col md={2} sm={2} xs={2} className="datePicker">
                  ~
                </Col>
                <Col md={5} sm={5} xs={5} className="datePicker">
                  <DatePikerForm 
                    englishDate={this.state.tripListTo} 
                    maxDate={this.state.today}
                    minDate={this.state.tripListFrom}
                    isDate={true} 
                    selectDate={this.selectDateTo} 
                  />
                </Col>

                <Col md={12} sm={12} xs={12}>
                  <TripListTable 
                    data={this.state.tripListData} 
                    formatter={this.formatTripListCell} 
                    isTripList={this.state.isTripList} 
                    tripListFrom={this.state.tripListFrom} 
                    tripListTo={this.state.tripListTo} 
                    onTripListSortChange={this.onTripListSortChange} 
                    onTripListPageChange={this.onTripListPageChange} 
                    isLink={this.state.isLink} 
                    tripListPageNum={this.state.tripListPageNum} 
                    tripListSortName={this.state.tripListSortName} 
                    tripListSortOrder={this.state.tripListSortOrder} 
                    getPeriodSpecifiedTripList={this.getPeriodSpecifiedTripList} 
                    tripListLoading={this.state.tripListLoading} 
                  />
                </Col>
              </Row>
            </div>
          </Route>
        </Switch>
      </div >
    );
  }
}

export default withTranslation()(TripReport);



// WEBPACK FOOTER //
// ./src/component/TripReport/TripReport.js